import React from "react"

type Props = React.HtmlHTMLAttributes<"div">

export function Card(props: Props) {

  return <div className="text-black leading-6 bg-white h-full mb-14 border-solid border-gray-100 border rounded-md shadow-[_-1px_1px_24px_-9px_rgba(0,0,0,0.75)] p-5 box-border">
    {props.children}
  </div>


}